<template>
  <div class="error-container">
    <div class="error-content">
      <h1 class="error-code">404</h1>
      <h2 class="error-title">{{ $t('page_not_found') || 'Sayfa Bulunamadı' }}</h2>
      <p class="error-message">
        {{ $t('page_not_found_desc') || 'Aradığınız sayfa bulunamadı.' }}
      </p>
      <button class="btn-home" @click="redirect">
        {{ $t("back-to-menu") || 'Ana Sayfaya Dön' }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    redirect() {
      window.location.href = "/";
    },
  },
  computed: {
    language: {
      get() {
        return this.$i18n?.locale || 'tr';
      },
    },
  },
};
</script>

<style scoped>
.error-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #042333 0%, #063044 100%);
  padding: 2rem;
}

.error-content {
  text-align: center;
  max-width: 600px;
}

.error-code {
  font-size: 10rem;
  font-weight: 700;
  color: #e7bb7f;
  margin: 0;
  line-height: 1;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
}

.error-title {
  font-size: 2.5rem;
  color: #ffffff;
  margin: 1rem 0;
  font-family: "Cormorant Garamond", Georgia, serif;
}

.error-message {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.8);
  margin: 1.5rem 0;
}

.btn-home {
  background-color: #e7bb7f;
  color: #042333;
  border: 2px solid #e7bb7f;
  padding: 1rem 3rem;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-top: 2rem;
  font-family: "Cormorant Garamond", Georgia, serif;
}

.btn-home:hover {
  background-color: transparent;
  color: #e7bb7f;
  border-color: #e7bb7f;
  transform: translateY(-2px);
}

@media (max-width: 768px) {
  .error-code {
    font-size: 6rem;
  }

  .error-title {
    font-size: 1.75rem;
  }

  .error-message {
    font-size: 1rem;
  }

  .btn-home {
    padding: 0.75rem 2rem;
    font-size: 1rem;
  }
}
</style>
